import { useState } from 'react'
import type { useCards } from './useCards'
import { DeckList } from './DeckList'
import { ItemSheet, KnowsPanel } from './KnowsPanel'

type Cards = ReturnType<typeof useCards>

/**
 * Her decks, and what she knows. Today's session starts from the top of the
 * Playroom; this is the part for the evening, when there is time to look.
 */
export function CardsSection({ cards, onNewDeck }: { cards: Cards; onNewDeck: () => void }) {
  const [tab, setTab] = useState<'decks' | 'knows'>('decks')
  const [item, setItem] = useState<{ items: string[]; title?: string } | null>(null)
  const onItem = (items: string[], title?: string) => setItem({ items, title })

  return (
    <>
      <div className="tabs cards-tabs" role="tablist" aria-label="Cards">
        {([['decks', 'Decks'], ['knows', 'What she knows']] as const).map(([key, label]) => (
          <button
            key={key}
            role="tab"
            id={`cardstab-${key}`}
            aria-selected={tab === key}
            aria-controls={`cardspanel-${key}`}
            className={`tab${tab === key ? ' is-active' : ''}`}
            onClick={() => setTab(key)}
          >
            {label}
          </button>
        ))}
      </div>

      <div role="tabpanel" id={`cardspanel-${tab}`} aria-labelledby={`cardstab-${tab}`} className="cards-panel">
        {tab === 'decks' ? (
          <DeckList cards={cards} onNewDeck={onNewDeck} onItem={onItem} />
        ) : (
          <KnowsPanel cards={cards} onItem={onItem} />
        )}
      </div>

      {item && <ItemSheet items={item.items} title={item.title} cards={cards} onClose={() => setItem(null)} />}
    </>
  )
}
